import { Datatype, isPlainDatatype } from '../../../datatype/Datatype.ts';
import { createConditionOperator } from '../IConditionOperator.ts';

export const ConditionOperatorDefinedType = createConditionOperator({
  code: 'defined',
  label: 'definito',
  description: 'Definito',
  args: [],
  allowsField: field =>
    isPlainDatatype(field.type) || field.type === Datatype.File,
  compare(value: any) {
    return value != null;
  },
});
